import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';

import { environment } from 'environments/environment';
import { generalReducers } from './general/reducers';
import { temporaryReducers } from './temporary/reducers';
import { temporaryEffects } from './temporary/effects';
import { generalEffects } from './general/effects';

export const metaReducers: MetaReducer<any>[] = !environment.production
  ? []
  : [];

@NgModule({
  imports: [
    StoreModule.forFeature('general', generalReducers),
    StoreModule.forFeature('temporary', temporaryReducers),
    EffectsModule.forRoot([...generalEffects, ...temporaryEffects]),
  ],
})
export class AppStoreModule {}
